export enum StorageType {
	cookie = 'Cookie',
	sessionStorage = 'sessionStorage',
	localStorage = 'localStorage',
	inMemory = 'inMemory'
}

export enum StorageServiceKey {
	rememberMe = 'rememberMe',
	sideNavOpenState = 'sideNavOpenState',
	returnUrl = 'returnUrl'
}

export const storageStore = 'z5Store';
